import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import InlineBanner, {InlineBannerActionType, InlineBannerType} from 'ui-library/banners/InlineBanner';

export default function FlexibleDataEntryInfoBanner(): JSX.Element {
  return (
    <InlineBanner
      bannerType={InlineBannerType.INFO}
      text={
        <span>
          This feature is powered by AI, and may make mistakes. See the{' '}
          <a
            href="https://help.benchling.com/hc/en-us/articles/34900709662989"
            target="_blank"
            rel="noopener noreferrer"
          >
            help article
          </a>{' '}
          for more information.{' '}
          {BenchlingConfig.LLM_SHOW_HUMAN_REVIEW_DISCLAIMER &&
            ' A human may review inputs and outputs to improve the feature.'}
          <br />
          <span className={css(styles.usageLimit)}>
            This feature is in beta. Usage limits may apply as we prepare for general availability.
          </span>
        </span>
      }
      supportingInfo={
        <span>
          To decide which data to enter, the AI system will analyze the content of your entry and any files
          you attach. For more information on AI security and privacy, look{' '}
          <a
            href="https://help.benchling.com/hc/en-us/articles/20901323667853-Security-and-privacy-for-LLMs-and-AI-powered-features"
            target="_blank"
            rel="noopener noreferrer"
          >
            here
          </a>
          .
        </span>
      }
      action={{actionType: InlineBannerActionType.ACCORDION}}
    />
  );
}

const styles = StyleSheet.create({
  usageLimit: {
    fontWeight: 'normal',
  },
});
